<div class="bg-night text-white max-h-[90vh] overflow-hidden flex flex-col">
  <div class="p-4 lg:p-6 border-b border-white/10 flex items-center justify-between">
    <div class="flex items-center gap-3">
      <div class="w-12 h-12 rounded-full bg-red-500/20 flex items-center justify-center">
        <span class="material-symbols-outlined text-2xl text-red-400">money_off</span>
      </div>
      <div>
        <h2 class="text-lg lg:text-xl font-bold">{{ 'pos.tabs.writeoff.title' | translate }}</h2>
        <p class="text-xs text-white/50">{{ tabName }}</p>
      </div>
    </div>
    <button
      type="button"
      (click)="close()"
      [disabled]="submitting()"
      class="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 transition-colors flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed">
      <span class="material-symbols-outlined">close</span>
    </button>
  </div>

  <div class="flex-1 overflow-y-auto p-4 lg:p-6 space-y-4">
    <div class="flex items-center justify-between">
      <h3 class="text-sm font-medium text-white/60">{{ 'pos.tabs.writeoff.select_items' | translate }}</h3>
      <button
        type="button"
        data-testid="writeoff-toggle-all"
        (click)="allSelected() ? clearAll() : selectAll()"
        class="px-3 py-1 rounded-lg bg-white/10 text-xs font-medium text-white/70 hover:bg-white/20 transition-colors">
        {{ allSelected() ? ('pos.tabs.writeoff.clear_all' | translate) : ('pos.tabs.writeoff.select_all' | translate) }}
      </button>
    </div>

    <div class="space-y-2">
      @for (item of lineItems(); track item.orderItemId) {
        <div
          data-testid="writeoff-item"
          [attr.data-product-name]="item.name"
          class="bg-white/5 rounded-xl p-3 flex items-center justify-between gap-3 transition-all"
          [ngClass]="{ 'border border-red-500/30 bg-red-500/5': item.selectedQty > 0 }">
          <div class="flex-1 min-w-0">
            <span class="text-sm font-medium text-white truncate block">{{ item.name }}</span>
            <span class="text-xs text-white/50">
              {{ item.unitPriceCents / 100 | number: '1.2-2' }} € · {{ item.availableQty }}
              {{ 'pos.tabs.writeoff.available' | translate }}
            </span>
            @if (isPartlyPaid(item)) {
              <span
                data-testid="writeoff-item-partly-paid"
                class="text-xs text-gold block">
                {{ 'pos.tabs.writeoff.partly_paid' | translate }} {{ item.outstandingCents / 100 | number: '1.2-2' }} €
              </span>
            }
          </div>
          <div class="flex items-center gap-2 shrink-0">
            <button
              type="button"
              data-testid="writeoff-item-decrement"
              (click)="decrementQty(item.orderItemId)"
              [disabled]="item.selectedQty === 0"
              class="w-8 h-8 rounded-full bg-white/10 hover:bg-white/20 transition-colors flex items-center justify-center disabled:opacity-30 disabled:cursor-not-allowed">
              <span class="material-symbols-outlined text-sm">remove</span>
            </button>
            <span
              class="w-8 text-center text-sm font-bold"
              data-testid="writeoff-item-qty"
              [class.text-red-400]="item.selectedQty > 0"
              >{{ item.selectedQty }}</span
            >
            <button
              type="button"
              data-testid="writeoff-item-increment"
              (click)="incrementQty(item.orderItemId)"
              [disabled]="item.selectedQty === item.availableQty"
              class="w-8 h-8 rounded-full bg-white/10 hover:bg-white/20 transition-colors flex items-center justify-center disabled:opacity-30 disabled:cursor-not-allowed">
              <span class="material-symbols-outlined text-sm">add</span>
            </button>
          </div>
        </div>
      }
    </div>

    <div>
      <label class="block text-sm text-white/60 mb-2">{{ 'pos.tabs.writeoff.reason' | translate }} *</label>
      <textarea
        data-testid="writeoff-reason"
        [ngModel]="reason()"
        (ngModelChange)="reason.set($event)"
        rows="3"
        class="w-full bg-transparent border border-white rounded-xl py-3 px-4 text-white placeholder-white/50 focus:outline-none focus:border-red-500 transition-all resize-none"
        placeholder="{{ 'pos.tabs.writeoff.reason_placeholder' | translate }}"></textarea>
    </div>

    <div class="bg-white/5 rounded-xl p-4">
      <div class="flex justify-between items-center">
        <div>
          <span class="text-white/60">{{ 'pos.tabs.writeoff.summary' | translate }}</span>
          @if (hasSelection()) {
            <p class="text-xs text-white/40 mt-0.5">
              {{ selectedItems().length }} {{ 'pos.tabs.writeoff.items_selected' | translate }}
            </p>
          }
        </div>
        <span
          class="text-xl font-bold text-red-400"
          data-testid="writeoff-total"
          >{{ totalWriteOffCents() / 100 | number: '1.2-2' }} €</span
        >
      </div>
    </div>
  </div>

  <div class="p-4 lg:p-6 border-t border-white/10 space-y-3">
    <button
      type="button"
      data-testid="writeoff-confirm"
      (click)="confirm()"
      [disabled]="!canConfirm() || submitting()"
      class="w-full py-3 px-6 rounded-full bg-red-500 text-white font-bold hover:bg-red-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center justify-center gap-2 uppercase">
      @if (submitting()) {
        <mat-spinner
          diameter="20"
          color="primary"></mat-spinner>
      } @else {
        <span class="material-symbols-outlined">check</span>
      }
      {{ 'pos.tabs.writeoff.confirm' | translate }}
    </button>
    <button
      type="button"
      data-testid="writeoff-cancel"
      (click)="close()"
      [disabled]="submitting()"
      class="w-full py-3 px-6 rounded-full border border-white/20 text-white font-medium hover:bg-white/10 transition-colors flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed">
      <span class="material-symbols-outlined">arrow_back</span>
      {{ 'admin.common.cancel' | translate }}
    </button>
  </div>
</div>
